import { Image, Avatar, Flex, Box } from '@chakra-ui/react';
import LaunchdeckSpinner from './LaunchdeckSpinner';

export default function UserProfileImageDisplay({profilePicture, name, size, uploadProfilePictureInProgress}) {

  const displaySize = size ? size : "2.2em"
  if(profilePicture) {
    return (
      <Box position='relative' height={displaySize} width={displaySize} rounded='50%' border='1px' borderColor='gray.300' bg='white' >
        <Box className='edit-photo-overlay'></Box>
        {uploadProfilePictureInProgress ? 
        
          <Flex zIndex={20} h={displaySize} justify='center' align='center'>
             <LaunchdeckSpinner boxSize='2em' thickness='3px'/>
			    </Flex>
          :
        <Box zIndex={10} top='0px' left='0px' >
          <Image boxSize={displaySize} rounded="full" objectFit="cover" src={profilePicture} />
        </Box>
  }
      </Box>
    )
  } else return (
      <Avatar 
      boxSize ={displaySize} 
      fontSize='1em'
      name={name} bg='gray.100' color='gray.700'/>
    )

}